import { render } from "./BtnHeader.vue?vue&type=template&id=1c8cd27e&scoped=true"
import script from "./BtnHeader.vue?vue&type=script&lang=js"
export * from "./BtnHeader.vue?vue&type=script&lang=js"

import "./BtnHeader.vue?vue&type=style&index=0&id=1c8cd27e&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8cd27e"]])

export default __exports__